import Body from '../body/Body';
import Entry from './entry/Entry';
import Scroller from './scroller/Scroller';
import { $playerReferrals, ReferralStatus } from '../../../../../app/backend/store/referrals';
import { HackneyGraphId } from '../../../../../types/alice-bob';

export default class Board extends Phaser.GameObjects.Container {
    private entries: Entry[] = [];
    private content!: Phaser.GameObjects.Container;
    private scroller!: Scroller;

    constructor(scene: Phaser.Scene, x: number, y: number) {
        super(scene, x, y);

        this.setupScroller();

        this.content = this.scene.add.container(0, 0);
        this.add(this.content);

        $playerReferrals.watch(incomingReferrals => this.setupEntries(incomingReferrals))
    }

    setupEntries(incomingReferrals: Array<ReferralStatus>) {
        this.content.remove(this.entries, true)
        this.entries = new Array();

        for (let i = 0; i < incomingReferrals.length; i++) {
            let x = 0;
            let y = i * Entry.HEIGHT;

            let config = {
                ...incomingReferrals[i].data,
                place: i + 1,
                claimed: incomingReferrals[i].claimed
            };

            let entry = new Entry(this.scene, x, y, config);
            this.content.add(entry);

            this.entries.push(entry);
        }
    }

    setupScroller() {
        let x = 0;
        let y = -Entry.HEIGHT / 2;

        this.scroller = new Scroller(this.scene, x, y);
        this.add(this.scroller);

        this.scroller.on('moved', this.onScrollerMoved, this);
    }

    onScrollerMoved(deltaY: number) {
        let minY = -Entry.HEIGHT * this.entries.length + Body.MASK.HEIGHT;
        let maxY = 0;

        this.content.y = Phaser.Math.Clamp(this.content.y + deltaY, minY, maxY);
    }
}
